/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");


const wellDefinedErrors = [
  'BADPASSWORD',
  'BADACCOUNT',
  'ACCINACTIVE',
  'BADTOKEN',
];

export function parseAPIError(error) {
  // well-defined errors
  const code = error._code || error.error;
  const message = error._message || error.message;
  const defined = wellDefinedErrors.filter(c => c === code);
  if (defined.length > 0) {
    return {
      code: defined[0],
      message,
      origin: error,
    };
  }

  // ill-defined errors, need some tweaks :p
  switch (code) {
    case 'TypeError':
      if (message === 'Failed to fetch') {
        return {
          code: 'FETCHFAILED',
          message,
          origin: error,
        };
      }
      break;
    default:
      break;
  }
  return {
    code: code || 'UNKNOWN',
    message,
    origin: error,
  };
}




// WEBPACK FOOTER //
// ./src/api/error.js